import { breakpoint } from '@/helpers/BreakpointHelper';
import React, { FC } from 'react';
import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
`;

const SkeletonBar = styled.div<{ width?: string }>`
  display: inline-block;
  height: 20px;
  width: ${({ width }) => width || '60%'};
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s ease-in-out infinite;
  border-radius: 4px;
  ${breakpoint(640)} {
    height: 16px;
  }
`;

const SkeletonRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 32px 0;
  border-bottom: 1px solid #e5e6e8;
  ${breakpoint(640)} {
    padding: 24px 0;
  }
`;

const SkeletonLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
`;

const SkeletonRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

const Container = styled.div`
  border-top: 1px solid #e5e6e8;
`;

interface ListSkeletonProps {
  rows?: number;
}

const ListSkeleton: FC<ListSkeletonProps> = ({ rows = 4 }) => (
  <Container>
    {Array.from({ length: rows }).map((_, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <SkeletonRow key={`skeleton-row-${i}`}>
        <SkeletonLeft>
          <SkeletonBar width="80px" />
          <SkeletonBar width="40%" />
        </SkeletonLeft>
        <SkeletonRight>
          <SkeletonBar width="100px" />
          <SkeletonBar width="24px" />
        </SkeletonRight>
      </SkeletonRow>
    ))}
  </Container>
);

export default ListSkeleton;
